import { VsAlert } from '@vuesax-alpha/components/alert'
import { VsAvatar, VsAvatarGroup } from '@vuesax-alpha/components/avatar'
import { VsBadge } from '@vuesax-alpha/components/badge'
import { VsButton, VsButtonGroup } from '@vuesax-alpha/components/button'
import { VsCard, VsCardGroup } from '@vuesax-alpha/components/card'
import { VsCheckbox, VsCheckboxGroup } from '@vuesax-alpha/components/checkbox'
import { VsCol } from '@vuesax-alpha/components/col'
import { VsCollapseTransition } from '@vuesax-alpha/components/collapse-transition'
import { VsDialog } from '@vuesax-alpha/components/dialog'
import { VsIcon } from '@vuesax-alpha/components/icon'
import { VsInput } from '@vuesax-alpha/components/input'
import { VsInputNumber } from '@vuesax-alpha/components/input-number'
import {
  VsNavbar,
  VsNavbarGroup,
  VsNavbarItem,
} from '@vuesax-alpha/components/navbar'
import { VsPagination } from '@vuesax-alpha/components/pagination'
import { VsPopconfirm } from '@vuesax-alpha/components/popconfirm'
import { VsPopper } from '@vuesax-alpha/components/popper'
import { VsRadio } from '@vuesax-alpha/components/radio'
import { VsRate } from '@vuesax-alpha/components/rate'
import { VsRow } from '@vuesax-alpha/components/row'
import { VsScrollbar } from '@vuesax-alpha/components/scrollbar'
import {
  VsOption,
  VsOptionGroup,
  VsSelect,
} from '@vuesax-alpha/components/select'
import {
  VsSidebar,
  VsSidebarGroup,
  VsSidebarItem,
} from '@vuesax-alpha/components/sidebar'
import { VsSwitch } from '@vuesax-alpha/components/switch'
import { VsTable, VsTd, VsTh, VsTr } from '@vuesax-alpha/components/table'
import { VsTimeSelect } from '@vuesax-alpha/components/time-select'
import { VsTooltip } from '@vuesax-alpha/components/tooltip'

import type { Plugin } from 'vue'

export default [
  VsAlert,
  VsAvatar,
  VsAvatarGroup,
  VsBadge,
  VsButton,
  VsButtonGroup,
  VsCard,
  VsCardGroup,
  VsCheckbox,
  VsCheckboxGroup,
  VsCol,
  VsCollapseTransition,
  VsDialog,
  VsIcon,
  VsInput,
  VsInputNumber,
  VsOptionGroup,
  VsOption,
  VsNavbar,
  VsNavbarGroup,
  VsNavbarItem,
  VsPagination,
  VsPopconfirm,
  VsPopper,
  VsRadio,
  VsRate,
  VsRow,
  VsScrollbar,
  VsSelect,
  VsSwitch,
  VsSidebar,
  VsSidebarGroup,
  VsSidebarItem,
  VsTable,
  VsTd,
  VsTh,
  VsTr,
  VsTimeSelect,
  VsTooltip,
] as Plugin[]
